module.exports = __webpack_public_path__ + "img/longquan1.eafe454a.png";